import { type Common } from '../common.js';
import type * as PayorClearinghouse from '../models/payor/clearinghouse.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    query?: PayorClearinghouse.FindAllOptions
  ): Promise<PayorClearinghouse.PayorClearinghouse[]> {
    const url = this.common.constructPath('/payor-clearinghouses/', query);
    return await this.common.getJSON(url);
  }
}
